export default "__VITE_ASSET__BzGuUaab__"